import { Injectable } from "@angular/core";
import {Adapter} from "./adapter"

export class User {
    

    constructor(
        public public_id: string, 
        public firstName: string,
        public lastName: string,
        public email: string,
        public password: string,
        public createdAt: Date, 
        public updatedAt: Date | null,
        public languageCode: string = 'en-US',
        ) {}
}

@Injectable({
    providedIn: "root",
})

export class UserAdapter implements Adapter<User> {

    constructor() { }

    adapt(item: any): User {
        
        const updatedAt = item.updated_at ? new Date(item.updated_at) : null;

        let user = new User(
                            item.public_id, 
                            item.firstname, 
                            item.lastname, 
                            item.email, 
                            '', // Password is not returned from the server for security reasons
                            new Date(item.created_at), 
                            updatedAt, 
                            item.language_code);
        
        return user;
    }

    adaptToApi(user: User): any {
        return {
            firstname: user.firstName,
            lastname: user.lastName,
            email: user.email,
            language_code: user.languageCode,
            
        }
    }
}
